import axios from "@/utils/axios";
import { GetOneCompositionGroupResponse } from "@/api/compositions/get-one-composition-group.response";
import { Guid } from "@/domain/guid";
import { GetCompositionGroupsResponse } from "@/api/compositions/get-composition-groups.response";
import { CreateCompositionGroupRequest } from "@/api/compositions/create-composition-group.request";
import { SetSignupStateRequest } from "@/api/compositions/set-signup-state.request";

export default {
	async fetchCompositions(teamID: Guid, month: number, year: number): Promise<GetCompositionGroupsResponse> {
		return (await axios().get(`/compositions?month=${month}&year=${year}&teamID=${teamID}`)).data;
	},
	async fetchCompositionGroup(
		compositionGroupID: Guid,
		withSignups = false,
		withCompositions = false,
		withUnknownSignups = false
	): Promise<GetOneCompositionGroupResponse> {
		
		const arrayFields: string[] = [];
		if (withSignups) {
			arrayFields.push("signups");
		}
		if (withCompositions) {
			arrayFields.push("compositions");
		}
		if (withUnknownSignups) {
			arrayFields.push("signups-unknown");
		}
		return (await axios().get(`/compositions/${compositionGroupID}?fields=${arrayFields.join(",")}`)).data;
	},
	async createComposition(teamID: Guid, payload: CreateCompositionGroupRequest): Promise<Guid> {
		return (await axios().post(`/compositions/create?teamID=${teamID}`, payload)).data;
	},
	async editComposition(compositionGroupID: Guid, payload: any): Promise<Guid> {
		return (await axios().put(`/compositions/${compositionGroupID}/meta`, payload)).data;
	},
	async copyComposition(compositionToCopyID: Guid, destinationDate: string): Promise<void> {
		return (await axios().post(`/compositions/copy/${compositionToCopyID}/${destinationDate}`)).data;
	},
	async deleteCompositionGroup(compositionGroupID: Guid): Promise<void> {
		return (await axios().delete(`/compositions/${compositionGroupID}`)).data;
	},
	async saveAll(compositionGroup: any): Promise<void> {
		return (await axios().put(`/compositions/${compositionGroup.id}`, compositionGroup)).data;
	},
	async setSignupState(compositionGroupID: Guid, payload: SetSignupStateRequest): Promise<void> {
		return (await axios().post(`/compositions/setSignupState/${compositionGroupID}`, payload)).data;
	},
	async broadcastToDiscord(compositionID: Guid): Promise<void> {
		return (await axios().post(`/compositions/composition/${compositionID}/discord`)).data;
	},
	async togglePublished(compositionGroupID: Guid): Promise<void> {
		return (await axios().patch(`/compositions/${compositionGroupID}/togglePublished`)).data;
	},
	async toggleLocked(compositionGroupID: Guid): Promise<void> {
		return (await axios().patch(`/compositions/${compositionGroupID}/toggleLocked`)).data;
	},
};